module.exports = __webpack_public_path__ + "media/images/front/top/minpre_award-e7efe3e813701169a3bb98eb7bd34e0e.jpeg";